import { useTranslation } from 'react-i18next'

import { useSnackbar } from '@context/SnackbarContext'

import { copyToClipboard } from '@utils/navigator.utils'

export const useCopy = (copyLabel?: string) => {
  const { addSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const copy = (value: string | number | undefined, label: string | undefined = copyLabel) => {
    copyToClipboard(value)
    addSnackbar.success({ message: label ? label : t('Text/link copied!') })
  }

  return { copy }
}
